import React from 'react';
import ListItem from '../../list-items/ListItem';

import './SnapshotList.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value} 
      placeholder={props.placeholder}
    />
  )
})  

const SnapshotList = (props) => {
  return (
    <>
      <div className="snapshotListTit">생성 스냅샷 목록</div>
      <div className="snapshotSearch">
        <InputText placeholder="스냅샷 명 검색" onChange={props.handleSearchInput} value={props.snapshotFilter} name="textfield" type="text" className="box" id="textfield" size="25" />
        <a onClick={()=>{
          props.handleSearchBtn(JSON.stringify(props.snapshotLabelData))
          // }} className="button purple_line" style={{padding: "5px 15px", marginLeft: "4px"}}>검색</a>
          }} className="button purple_line" style={{marginLeft: "4px"}}>검색</a>
          </div>
      <div className="createSnapshotGroup">
        <div className="overflow-component">
          {props.filteredArray.info && props.filteredArray.info.map( (item, index) => 
            <div className="snapshotGroup">
              <ListItem type={props.filteredArray.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
            </div>
          )}
          {props.filteredArray.nullLabelItem && props.filteredArray.nullLabelItem.map( (item, index) => 
            <ListItem handleClick={props.handleClick} type={props.filteredArray.nullLabelItemType} key={item.name+index} item={item} index={index} />
          )}
        </div>
      </div>
    </>
  )
}

export default SnapshotList;